/**
 * 네트워크 정보를 반환합니다.
 * Navigator.connection API 기반으로 수집합니다.
 * 포맷: {effectiveType}/{downlink}Mbps/{rtt}ms (+ /{type} 가능 시)
 * 예: "4g/10Mbps/50ms", "4g/10Mbps/50ms/wifi"
 * 미지원 브라우저(Safari, Firefox 등): ""
 */
export const getNetworkInfo = (): string => {
  if (typeof window === 'undefined') return '';

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const conn = (navigator as any).connection;
  if (!conn) return '';

  const effectiveType = conn.effectiveType ?? 'unknown';
  const downlink = conn.downlink != null ? `${conn.downlink}Mbps` : 'unknown';
  const rtt = conn.rtt != null ? `${conn.rtt}ms` : 'unknown';

  const base = `${effectiveType}/${downlink}/${rtt}`;

  // type(wifi, cellular, ethernet 등)은 모바일에서만 제공 — 있으면 추가
  return conn.type ? `${base}/${conn.type}` : base;
};
